/** A sales dispatch kind's list: Pack Seed, Bulk, TDF, Material Discard. */
import { DISPATCH_KINDS, DISPATCH_TABS } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { DispatchListPage } from "@/features/sales-dispatch/components/dispatch-list-page";

const search = z.object({
  tab: z.enum(DISPATCH_TABS).default("draft"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/dispatch/sales/$kind/")({
  validateSearch: search,
  params: { parse: (p) => ({ kind: z.enum(DISPATCH_KINDS).parse(p.kind) }) },
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <DispatchListPage
      key={kind}
      kind={kind}
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
